import comm_bell from './comm-bell.svg';
import comm_bell_add from './comm-bell-add.svg';
import comm_bell_close from './comm-bell-close.svg';
import comm_bell_notification from './comm-bell-notification.svg';
import comm_bell_off from './comm-bell-off.svg';
import comm_bell_remove from './comm-bell-remove.svg';
import comm_bell_ring from './comm-bell-ring.svg';
import comm_chat from './comm-chat.svg';
import comm_chat_add from './comm-chat-add.svg';
import comm_chat_check from './comm-chat-check.svg';
import comm_chat_circle from './comm-chat-circle.svg';
import comm_chat_circle_add from './comm-chat-circle-add.svg';
import comm_chat_circle_check from './comm-chat-circle-check.svg';
import comm_chat_circle_close from './comm-chat-circle-close.svg';
import comm_chat_circle_dots from './comm-chat-circle-dots.svg';
import comm_chat_circle_remove from './comm-chat-circle-remove.svg';
import comm_chat_close from './comm-chat-close.svg';
import comm_chat_conversation from './comm-chat-conversation.svg';
import comm_chat_conversation_circle from './comm-chat-conversation-circle.svg';
import comm_chat_dots from './comm-chat-dots.svg';
import comm_chat_remove from './comm-chat-remove.svg';
import comm_inbox from './comm-inbox.svg';
import comm_mail from './comm-mail.svg';
import comm_mail_open from './comm-mail-open.svg';
import comm_paper_plane from './comm-paper-plane.svg';
import comm_phone from './comm-phone.svg';
import comm_share_ios_export from './comm-share-ios-export.svg';
import comm_shared_android from './comm-shared-android.svg';

export const V2_COMMUNICATION_ICONS: { [char: string]: string } = {
  comm_bell,
  comm_bell_add,
  comm_bell_close,
  comm_bell_notification,
  comm_bell_off,
  comm_bell_remove,
  comm_bell_ring,
  comm_chat,
  comm_chat_add,
  comm_chat_check,
  comm_chat_circle,
  comm_chat_circle_add,
  comm_chat_circle_check,
  comm_chat_circle_close,
  comm_chat_circle_dots,
  comm_chat_circle_remove,
  comm_chat_close,
  comm_chat_conversation,
  comm_chat_conversation_circle,
  comm_chat_dots,
  comm_chat_remove,
  comm_inbox,
  comm_mail,
  comm_mail_open,
  comm_paper_plane,
  comm_phone,
  comm_share_ios_export,
  comm_shared_android,
};

export const V2_COMMUNICATION_ICON_NAMES: string[] = Object.keys(V2_COMMUNICATION_ICONS);
